import { render, staticRenderFns } from "./MutedTip.vue?vue&type=template&id=ed458db8&"
import script from "./MutedTip.vue?vue&type=script&lang=js&"
export * from "./MutedTip.vue?vue&type=script&lang=js&"
import style0 from "./MutedTip.vue?vue&type=style&index=0&id=ed458db8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports